// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1es8Q","top":"styles_top__3hq47","left":"styles_left__3esv_","description":"styles_description__3Gh4L"};